import { render } from "./Knowledgebase.vue?vue&type=template&id=eee61956"
import script from "./Knowledgebase.vue?vue&type=script&lang=js"
export * from "./Knowledgebase.vue?vue&type=script&lang=js"

import "./Knowledgebase.vue?vue&type=style&index=0&id=eee61956&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__